import React from 'react';

function Notch({color, textcolor}) {
    const notchStyle = {
        backgroundColor: color,        
      };
    const notchText ={
        color: textcolor
    };
  return (
    <div className="menu-bar" style={notchStyle}>
      <a style={notchText} href="#about">about</a>
      <a style={notchText} href="#about">contact</a>
    </div>
  );
}

export default Notch;
